import React from "react";
import DashboardLayout from "../DashboardLayout";

export default function Settings() {
  return (
    <DashboardLayout>
      <div className="flex min-h-screen w-full items-center justify-center text-white">This is Settigs.</div>
    </DashboardLayout>
  );
}
